import { checkRoute } from './authorization'

export default [
  async (to, from, next) => {
    await checkRoute(from, to)
    next()
  },
]
